import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { createPriceAdjustment } from '../../actions/purchaseOrders_actions';
import PriceAdjustmentDetail from '../../components/Purchase/priceAdjustmentDetail';

let priceAdjustmentDetail = reduxForm({
  form: 'priceAdjustmentDetail',
})(PriceAdjustmentDetail);

const selector = formValueSelector('priceAdjustmentDetail');

function mapStateToProps(state) {
    return {
      priceAdjustmentIsLoading: state.purchaseOrders.priceAdjustmentIsLoading,
      priceAdjustment: state.purchaseOrders.priceAdjustment,
      priceAdjustmentError: state.purchaseOrders.priceAdjustmentError,
    };
}

export default connect(mapStateToProps, { createPriceAdjustment })(priceAdjustmentDetail);



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/priceAdjustmentDetail.jsx